import React from "react";
import "./Checkbox.css";

export default function Checkbox({
  checked,
  label,
  id,
  onChange,
  hex,
  white,
  classNames = "",
  title = "",
  disabled = false,
}) {
  return (
    <label
      htmlFor={id}
      className={`checkbox ${classNames} ${
        disabled ? "checkbox--disabled" : ""
      }`}
      title={title}
    >
      <input
        disabled={disabled}
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className="checkbox__input"
      />
      {label}
      <p
        className={`checkbox__status ${
          checked ? "checkbox__status--on" : "checkbox__status--off"
        }`}
        style={{
          "--bg-color": checked ? hex : "inherit",
          "--text-color": checked ? (white ? "white" : "black") : "inherit",
        }}
      >
        {checked ? "On" : "Off"}
      </p>
    </label>
  );
}



// WEBPACK FOOTER //
// ./src/screens/BespokeCRMTabs/components/Checkbox.jsx